function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 3C14.1798 3 13.3992 3.16431 12.6884 3.46134C12.4336 3.56781 12.1407 3.44758 12.0343 3.19279C11.9278 2.938 12.048 2.64514 12.3028 2.53866C13.1336 2.1915 14.0451 2 15 2C18.866 2 22 5.13401 22 9C22 9.75062 21.8817 10.4746 21.6623 11.1537C21.5774 11.4165 21.2956 11.5607 21.0328 11.4758C20.77 11.3909 20.6258 11.1091 20.7107 10.8463C20.8984 10.2653 21 9.645 21 9C21 5.68629 18.3137 3 15 3ZM11 6C6.85786 6 3.5 9.35786 3.5 13.5C3.5 14.6776 3.77105 15.7905 4.25371 16.781C4.32319 16.9236 4.3209 17.0906 4.24753 17.2313L3.3248 19H5.70835C5.8302 19 5.94786 19.0445 6.03922 19.1251C7.36165 20.2923 9.09757 21 11 21C15.1421 21 18.5 17.6421 18.5 13.5C18.5 9.35786 15.1421 6 11 6ZM2.5 13.5C2.5 8.80558 6.30558 5 11 5C15.6944 5 19.5 8.80558 19.5 13.5C19.5 18.1944 15.6944 22 11 22C8.9135 22 7.0016 21.2476 5.5225 20H2.5C2.32518 20 2.16306 19.9087 2.07243 19.7592C1.9818 19.6097 1.97584 19.4237 2.0567 19.2687L3.2465 16.9881C2.76676 15.9233 2.5 14.7422 2.5 13.5ZM7 14.5C7.55228 14.5 8 14.0523 8 13.5C8 12.9477 7.55228 12.5 7 12.5C6.44772 12.5 6 12.9477 6 13.5C6 14.0523 6.44772 14.5 7 14.5ZM15 14.5C15.5523 14.5 16 14.0523 16 13.5C16 12.9477 15.5523 12.5 15 12.5C14.4477 12.5 14 12.9477 14 13.5C14 14.0523 14.4477 14.5 15 14.5ZM12 13.5C12 14.0523 11.5523 14.5 11 14.5C10.4477 14.5 10 14.0523 10 13.5C10 12.9477 10.4477 12.5 11 12.5C11.5523 12.5 12 12.9477 12 13.5Z",
  fill: "#FFAF00"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 23C16.9183 23 20.5 19.4183 20.5 15C20.5 10.5817 16.9183 7 12.5 7C8.08172 7 4.5 10.5817 4.5 15C4.5 19.4183 8.08172 23 12.5 23Z",
  fill: "#FFAF00",
  fillOpacity: 0.1
});
const SvgHelp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/help.6f63f011.svg";
export { ForwardRef as ReactComponent };